export const PDPlus_Choice_SubGroup_FAN_Discount_Name  = "FANDiscount"
export const PROVIDER_LOGO_MAP: Record<string, string> = {
    'at&t': 'pi pi-att',
    'att': 'pi pi-att',
    'charter': 'pi pi-charter',
    'spectrum': 'pi pi-charter', // Charter/Spectrum share the same icon
    'brightspeed': 'pi pi-brightspeed',
    'optimum': 'pi pi-optimum',
    'frontier': 'pi pi-frontier',
};

/** ATT sends ABP as ATT-INTERNET-ABP-* (SMB: ATT-INTERNET-SMB-ABP-*); OOF providers (Viasat) send it as INTERNET-ABPPPL-* / INTERNET-PAPERLESS-*. */
export const INTERNET_ABP_ENROLLED_CHOICE_CODES: string[] = ['ATT-INTERNET-ABP-BOTH-YES', 'ATT-INTERNET-SMB-ABP-BOTH-YES', 'ATT-INTERNET-SMB-ABP-AUTOPAY-YES', 'INTERNET-ABPPPL-YES'];

export const INTERNET_ABP_PAPERLESS_ONLY_CHOICE_CODES: string[] = ['ATT-INTERNET-ABP-PAPERLESS-YES', 'ATT-INTERNET-SMB-ABP-PAPERLESS-YES', 'INTERNET-PAPERLESS-YES'];

export const INTERNET_ABP_CHOICE_CODES: string[] = [...INTERNET_ABP_ENROLLED_CHOICE_CODES, ...INTERNET_ABP_PAPERLESS_ONLY_CHOICE_CODES];

export const INTERNET_ABP_SUB_GROUP_NAMES: string[] = ['ABP', 'AutopaySelection'];

export function isInternetAbpSubGroup(subGroupName: string | null | undefined): boolean {
    return !!subGroupName && INTERNET_ABP_SUB_GROUP_NAMES.includes(subGroupName);
}

export function isInternetAbpEnrolledChoiceCode(choiceCode: string | null | undefined): boolean {
    return !!choiceCode && INTERNET_ABP_ENROLLED_CHOICE_CODES.includes(choiceCode);
}

export const INTERNET_PROMOTION_CHOICE_PREFIX = 'INTERNET-PROMOTION-';

export function isInternetPromotionChoiceCode(choiceCode: string | null | undefined): boolean {
    return !!choiceCode && choiceCode.toUpperCase().startsWith(INTERNET_PROMOTION_CHOICE_PREFIX);
}

export const CLOSING_OFFER_DETAILED_GROUP_NAMES = ['ClosingOffers', 'ClosingOptionalOffers', 'ClosingAdditionalOffers'];

export function isClosingOfferGroup(detailedGroupName: string | null | undefined): boolean {
    return CLOSING_OFFER_DETAILED_GROUP_NAMES.includes(detailedGroupName ?? '');
}
export const PACKAGE_CAROUSEL_RESPONSIVE_OPTIONS = [
    { breakpoint: '6199px', numVisible: 5, numScroll: 1 }, // extra large monitors
    { breakpoint: '2799px', numVisible: 5, numScroll: 1 },
    { breakpoint: '2399px', numVisible: 4, numScroll: 1 },
    { breakpoint: '1999px', numVisible: 3, numScroll: 1 }, // laptops and smaller desktops
    { breakpoint: '1220px', numVisible: 2, numScroll: 1 }, // small laptops / tablets in landscape
    { breakpoint: '1024px', numVisible: 1.5, numScroll: 1 }, // tablets in portrait (e.g., iPads)
    { breakpoint: '767px', numVisible: 1, numScroll: 1 } // mobile devices
];

/** Email format check shared by every email field; allows any TLD of two or more letters (e.g. .global). */
export const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
